import React from 'react';
import PropTypes from 'prop-types';
import './MaxGuests.less';

import {SVGIcon} from '@homeaway/react-svg';
import {FAMILY__24} from '@homeaway/svg-defs';

import translate from '../../../../../../utils/translations';

export default function MaxGuests({
    adultsMax,
    isChildrenAllowed,
    sleeps,
    translations,
}) {
    const isMaxAdultsLessThanGuests = adultsMax < sleeps;
    return (
        <div className="MaxGuests">
            <div className="MaxGuests__icon">
                <SVGIcon markup={FAMILY__24} inlineFlex />
            </div>
            <div className="MaxGuests__description">
                <span className="text-muted">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'modifyBooking.guestSelector.maxNumOfGuests',
                        sleeps
                    )}
                    &nbsp;
                    {isMaxAdultsLessThanGuests && (
                        <span>
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'modifyBooking.guestSelector.maxAdults',
                                {ADULTS: adultsMax}
                            )}
                        </span>
                    )}
                </span>
                {!isChildrenAllowed && (
                    <span className="text-muted">
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'modifyBooking.guestSelector.childrenNotAllowed'
                        )}
                    </span>
                )}
            </div>
        </div>
    );
}

MaxGuests.defaultProps = {
    isChildrenAllowed: true,
    sleeps: 1,
};

MaxGuests.propTypes = {
    adultsMax: PropTypes.number.isRequired,
    isChildrenAllowed: PropTypes.bool.isRequired,
    sleeps: PropTypes.number.isRequired,
    translations: PropTypes.shape({}).isRequired,
};
